<script>
import {
  layoutComputed
} from "@/Template/State/Helpers";

export default {
  data() {
    return {
      settings: {
        minScrollbarLength: 60,
      },
    };
  },
  computed: {
    ...layoutComputed,
    layoutType: {
      get() {
        return this.$store ? this.$store.state.layout.layoutType : {} || {};
      },
    },
  },

  watch: {
    $route: {
      handler: "onRoutechange",
      immediate: true,
      deep: true,
    },
  },

  mounted() {
    this.initActiveMenu();
    if (this.rmenu == 'vertical' && this.layoutType == 'twocolumn') {
      document.documentElement.setAttribute("data-layout", "vertical");
    }
    document.getElementById('overlay')?.addEventListener('click', () => {
      document.body.classList.remove('vertical-sidebar-enable');
    });

    window.addEventListener("resize", () => {
      if (this.layoutType == 'twocolumn') {
        var windowSize = document.documentElement.clientWidth;
        if (windowSize < 767) {
          document.documentElement.setAttribute("data-layout", "vertical");
          this.rmenu = 'vertical';
          localStorage.setItem('rmenu', 'vertical');
        } else {
          document.documentElement.setAttribute("data-layout", "vertical");
          this.rmenu = 'twocolumn';
          localStorage.setItem('rmenu', 'twocolumn');
          setTimeout(() => {
            this.initActiveMenu();
          }, 50);

        }
      }
    });
    if (document.querySelectorAll(".navbar-nav .collapse")) {
      let collapses = document.querySelectorAll(".navbar-nav .collapse");

      collapses.forEach((collapse) => {
        // Hide sibling collapses on `show.bs.collapse`
        collapse.addEventListener("show.bs.collapse", (e) => {
          e.stopPropagation();
          let closestCollapse = collapse.parentElement.closest(".collapse");
          if (closestCollapse) {
            let siblingCollapses =
              closestCollapse.querySelectorAll(".collapse");
            siblingCollapses.forEach((siblingCollapse) => {
              if (siblingCollapse.classList.contains("show")) {
                siblingCollapse.classList.remove("show");
                siblingCollapse.parentElement.firstChild.setAttribute("aria-expanded", "false");
              }
            });
          } else {
            let getSiblings = (elem) => {
              // Setup siblings array and get the first sibling
              let siblings = [];
              let sibling = elem.parentNode.firstChild;
              // Loop through each sibling and push to the array
              while (sibling) {
                if (sibling.nodeType === 1 && sibling !== elem) {
                  siblings.push(sibling);
                }
                sibling = sibling.nextSibling;
              }
              return siblings;
            };
            let siblings = getSiblings(collapse.parentElement);
            siblings.forEach((item) => {
              if (item.childNodes.length > 2) {
                item.firstElementChild.setAttribute("aria-expanded", "false");
                item.firstElementChild.classList.remove("active");
              }
              let ids = item.querySelectorAll("*[id]");
              ids.forEach((item1) => {
                item1.classList.remove("show");
                item1.parentElement.firstChild.setAttribute("aria-expanded", "false");
                item1.parentElement.firstChild.classList.remove("active");
                if (item1.childNodes.length > 2) {
                  let val = item1.querySelectorAll("ul li a");

                  val.forEach((subitem) => {
                    if (subitem.hasAttribute("aria-expanded"))
                      subitem.setAttribute("aria-expanded", "false");
                  });
                }
              });
            });
          }
        });

        // Hide nested collapses on `hide.bs.collapse`
        collapse.addEventListener("hide.bs.collapse", (e) => {
          e.stopPropagation();
          let childCollapses = collapse.querySelectorAll(".collapse");
          childCollapses.forEach((childCollapse) => {
            let childCollapseInstance = childCollapse;
            childCollapseInstance.classList.remove("show");
            childCollapseInstance.parentElement.firstChild.setAttribute("aria-expanded", "false");
          });
        });
      });
    }
  },

  methods: {
    onRoutechange(ele) {
      this.initActiveMenu(ele.path);
      if (document.getElementsByClassName("mm-active").length > 0) {
        const currentPosition = document.getElementsByClassName("mm-active")[0].offsetTop;
        if (currentPosition > 500)
          if (this.$refs.isSimplebar)
            this.$refs.isSimplebar.value.getScrollElement().scrollTop = currentPosition + 300;
      }
    },

    initActiveMenu() {
      const pathName = window.location.pathname;
      const ul = document.getElementById("navbar-nav");
      if (ul) {
        const items = Array.from(ul.querySelectorAll("a.nav-link"));
        let activeItems = items.filter((x) => x.classList.contains("active"));
        this.removeActivation(activeItems);
        let matchingMenuItem = items.find((x) => {
          return x.getAttribute("href") === pathName;
        });
        if (matchingMenuItem) {
          this.activateParentDropdown(matchingMenuItem);
        } else {
          var id = pathName.replace("/", "");
          if (id) document.body.classList.add("twocolumn-panel");
          this.activateIconSidebarActive(pathName);
        }
      }
    },

    updateMenu(e, event) {

      document.body.classList.remove("twocolumn-panel");
      const ul = document.getElementById("navbar-nav");
      if (ul) {
        const items = Array.from(ul.querySelectorAll(".show"));
        items.forEach((item) => {
          item.classList.remove("show");
        });
      }
      const icons = document.getElementById("two-column-menu");
      if (icons) {
        const activeIcons = Array.from(
          icons.querySelectorAll(".nav-icon.active")
        );
        activeIcons.forEach((item) => {
          item.classList.remove("active");
        });
      }
      document.getElementById(e).classList.add("show");
      event.target.classList.add("active")
      this.activateIconSidebarActive("#" + e);
    },

    removeActivation(items) {
      items.forEach((item) => {
        if (item.classList.contains("menu-link")) {
          if (!item.classList.contains("active")) {
            item.setAttribute("aria-expanded", false);
          }

          item.nextElementSibling?.classList.remove("show");
        }
        if (item.classList.contains("nav-link")) {
          if (item.nextElementSibling) {
            item.nextElementSibling.classList.remove("show");
          }
          item.setAttribute("aria-expanded", false);
        }
        item.classList.remove("active");
      });
    },

    activateParentDropdown(item) {
      // navbar-nav menu add active
      item.classList.add("active");
      let parentCollapseDiv = item.closest(".collapse.menu-dropdown");
      if (parentCollapseDiv) {
        // to set aria expand true remaining
        parentCollapseDiv.classList.add("show");
        parentCollapseDiv.parentElement.children[0].classList.add("active");
        parentCollapseDiv.parentElement.children[0].setAttribute("aria-expanded", "true");
        if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
          if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown").previousElementSibling) {
            if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown").previousElementSibling.parentElement.closest(".collapse.menu-dropdown")) {
              const grandparent = parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown").previousElementSibling.parentElement.closest(".collapse.menu-dropdown");
              this.activateIconSidebarActive("#" + grandparent.getAttribute("id"));
              grandparent.classList.add("show");
            }
          }
          this.activateIconSidebarActive("#" + parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")
            .getAttribute("id"));

          parentCollapseDiv.parentElement.closest(".collapse").classList.add("show");
          if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling)
            parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.classList.add("active");
          return false;
        }
        this.activateIconSidebarActive("#" + parentCollapseDiv.getAttribute("id"));
        return false;
      }
      return false;
    },

    activateIconSidebarActive(id) {
      var menu = document.querySelector(
        "#two-column-menu .simplebar-content-wrapper a[href='" +
        id +
        "'].nav-icon"
      );
      if (menu !== null) {
        menu.classList.add("active");
      }
    },
  },
};
</script>

<template>
  <BContainer fluid>
    <div id="two-column-menu"></div>

    <template v-if="layoutType === 'vertical' || layoutType === 'semibox'">
      <ul class="navbar-nav h-100" id="navbar-nav">

        <li class="menu-title" v-if="$ac.hasAccesses([
          'dashboard_menu'
        ])">
          <span data-key="t-menu"> {{ $t("menu.header.menu") }}</span>
        </li>
        <li class="nav-item" v-if="$ac.hasAccess('dashboard_menu')">
          <router-link class="nav-link menu-link" :to="{ name: 'dashboard' }">
            <i class="mdi mdi-chart-box-outline"></i>
            <span data-key="t-dashboard">{{ $t("menu.sub_header.dashboard") }}</span>
          </router-link>
        </li>

        <li class="menu-title" v-if="$ac.hasAccesses([
          'reservation_menu',
        ])">
          <span data-key="t-menu"> {{ $t("menu.header.service") }}</span>
        </li>
        <router-link class="nav-link menu-link" :to="{ name: 'reservation' }"
        v-if="$ac.hasAccess('reservation_menu')">
          <i class="mdi mdi-calendar-clock"></i>
          <span data-key="t-user">{{ $t("menu.sub_header.reservation") }}</span>
        </router-link>

        <li class="menu-title" v-if="$ac.hasAccesses([
          'session_menu',
          'stuff_available_menu'
        ])">
          <span data-key="t-menu"> {{ $t("menu.header.reservation") }}</span>
        </li>
        <router-link class="nav-link menu-link" :to="{ name: 'branch-session' }"
        v-if="$ac.hasAccess('session_menu')">
          <i class="mdi mdi-timetable"></i>
          <span data-key="t-user">{{ $t("menu.sub_header.branch_session") }}</span>
        </router-link>
        <router-link class="nav-link menu-link" :to="{ name: 'stuff-available' }"
          v-if="$ac.hasAccess('stuff_available_menu')">
          <i class="mdi mdi-sofa-single-outline"></i>
          <span data-key="t-user">{{ $t("menu.sub_header.stuff_available") }}</span>
        </router-link>

        <li class="menu-title" v-if="$ac.hasAccesses([
          'store_menu',
          'branch_menu',
          'open_hour_menu',
          'special_day_menu',
          'room_menu',
          'stuff_menu',
          'employee_menu',
        ])">
          <span data-key="t-menu"> {{ $t("menu.header.restaurant") }}</span>
        </li>
        <router-link class="nav-link menu-link" :to="{ name: 'store' }"
        v-if="$ac.hasAccess('store_menu')">
          <i class="mdi mdi-storefront-outline"></i>
          <span data-key="t-user">{{ $t("menu.sub_header.store") }}</span>
        </router-link>
        <router-link class="nav-link menu-link" :to="{ name: 'branch' }"
        v-if="$ac.hasAccess('branch_menu')">
          <i class="mdi mdi-map-marker-outline"></i>
          <span data-key="t-user">{{ $t("menu.sub_header.branch") }}</span>
        </router-link>
        <li class="nav-item" v-if="$ac.hasAccesses([
          'open_hour_menu',
          'special_day_menu',
        ])">
          <a class="nav-link menu-link" href="#open_hours" data-bs-toggle="collapse" role="button" aria-expanded="false"
            aria-controls="sidebarMaps">
            <i class="mdi mdi-clock-time-four-outline"></i>
            <span data-key="t-maps">{{ $t("menu.sub_header.open_hour") }}</span>
          </a>
          <div class="collapse menu-dropdown" id="open_hours">
            <ul class="nav nav-sm flex-column">
              <li class="nav-item" v-if="$ac.hasAccess('open_hour_menu')">
                <router-link class="nav-link menu-link" :to="{ name: 'open-hour' }">
                  <i class="mdi mdi-repeat"></i>
                  <span data-key="t-user">{{ $t("menu.sub_header.open_hour_normal") }}</span>
                </router-link>
              </li>
              <li class="nav-item" v-if="$ac.hasAccess('special_day_menu')">
                <router-link class="nav-link menu-link" :to="{ name: 'special-day' }">
                  <i class="mdi mdi-star-outline"></i>
                  <span data-key="t-user">{{ $t("menu.sub_header.open_hour_special_day") }}</span>
                </router-link>
              </li>
            </ul>
          </div>
        </li>
        <router-link class="nav-link menu-link" :to="{ name: 'room' }" v-if="$ac.hasAccess('room_menu')">
          <i class="mdi mdi-view-quilt-outline"></i>
          <span data-key="t-user">{{ $t("menu.sub_header.room") }}</span>
        </router-link>
        <router-link class="nav-link menu-link" :to="{ name: 'stuff' }" v-if="$ac.hasAccess('stuff_menu')">
          <i class="mdi mdi-sofa-outline"></i>
          <span data-key="t-user">{{ $t("menu.sub_header.stuff") }}</span>
        </router-link>
        <router-link class="nav-link menu-link" :to="{ name: 'employee' }" v-if="$ac.hasAccess('employee_menu')">
          <i class="mdi mdi-account-tie-outline"></i>
          <span data-key="t-user">{{ $t("menu.sub_header.employee") }}</span>
        </router-link>

        <li class="menu-title" v-if="$ac.hasAccesses([
          'user_menu',
          'stuff_type_menu',
        ])">
          <span data-key="t-menu"> {{ $t("menu.header.master_data") }}</span>
        </li>
        <router-link class="nav-link menu-link" :to="{ name: 'user' }" v-if="$ac.hasAccess('user_menu')">
          <i class="mdi mdi-account-outline"></i>
          <span data-key="t-user">{{ $t("menu.sub_header.user") }}</span>
        </router-link>
        <router-link class="nav-link menu-link" :to="{ name: 'stuff-type' }" v-if="$ac.hasAccess('stuff_type_menu')">
          <i class="mdi mdi-shape-outline"></i>
          <span data-key="t-user">{{ $t("menu.sub_header.stuff_type") }}</span>
        </router-link>

        <li class="menu-title" v-if="$ac.hasAccesses([
          'config_general_menu',
          'config_email_template_menu',
          'permission_group_menu',
        ])">
          <span data-key="t-menu"> {{ $t("menu.header.other") }}</span>
        </li>
        <li class="nav-item" v-if="$ac.hasAccesses([
          'config_general_menu',
          'config_email_template_menu',
        ])">
          <a class="nav-link menu-link" href="#config" data-bs-toggle="collapse" role="button" aria-expanded="false"
            aria-controls="sidebarMaps">
            <i class="mdi mdi-cog-outline"></i>
            <span data-key="t-maps">{{ $t("menu.sub_header.config") }}</span>
          </a>
          <div class="collapse menu-dropdown" id="config">
            <ul class="nav nav-sm flex-column">
              <li class="nav-item" v-if="$ac.hasAccess('config_general_menu')">
                <router-link class="nav-link menu-link" :to="{ name: 'config-general' }">
                  <i class="mdi mdi-cog-transfer-outline"></i>
                  <span data-key="t-user">{{ $t("menu.sub_header.config_general") }}</span>
                </router-link>
              </li>
              <li class="nav-item" v-if="$ac.hasAccess('config_email_template_menu')">
                <router-link class="nav-link menu-link" :to="{ name: 'email-template' }">
                  <i class="mdi mdi-card-account-mail-outline"></i>
                  <span data-key="t-user">{{ $t("menu.sub_header.email_template") }}</span>
                </router-link>
              </li>
            </ul>
          </div>
        </li>
        <router-link class="nav-link menu-link" :to="{ name: 'permission-group' }"
          v-if="$ac.hasAccess('permission_group_menu')">
          <i class="mdi mdi-lock-outline"></i>
          <span data-key="t-user">{{ $t("menu.sub_header.permission_group") }}</span>
        </router-link>
      </ul>
    </template>
  </BContainer>
</template>